import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {NodeOutputData, NodeType} from 'common/src/modules/nodes/nodes.types';
import {DistributionCardScratchpadState} from '../../scratchpad/distributionCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';

const deleteDistributionOutputsInputSchema = z.object({
  outputIds: z
    .array(z.number())
    .describe('The ids of the outputs to delete, make sure that at least 2 outputs remain'),
});

export default function deleteDistributionOutputsTool() {
  async function execute(
    params: ToolExecuteParams<
      typeof deleteDistributionOutputsInputSchema,
      DistributionCardScratchpadState
    >,
  ) {
    const {outputIds} = params.input;
    const {agentScratchpad} = params.toolUtils;
    const validatedScratchpad = validateAgentScratchpad<DistributionCardScratchpadState>(
      agentScratchpad,
      NodeType.DISTRIBUTION,
    );

    const remainingOutputs = validatedScratchpad.card.outputs.filter(
      (output) => !outputIds.includes(output.id),
    ) as NodeOutputData[];

    if (remainingOutputs.length < 2) {
      return toolError('Cannot delete outputs: distribution cards must have at least 2 outputs');
    }

    validatedScratchpad.card.outputs = remainingOutputs;

    return toolResult(`Successfully deleted ${outputIds.length} output(s)`);
  }

  return tool<typeof deleteDistributionOutputsInputSchema, DistributionCardScratchpadState>({
    name: V2CardAgentToolName.DeleteDistributionOutputs,
    displayName: 'Deleting distribution outputs',
    description: 'Delete distribution outputs by ID. Minimum 2 outputs must remain.',
    inputSchema: deleteDistributionOutputsInputSchema,
    execute,
  });
}
